import type React from 'react';
import { CardHeader, Divider, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

import type { RequestProps } from '../../models/request.types';

const style = {
	divider: { borderBottomWidth: 1.5 },
};

interface ContactInfoProps {
	candidate: RequestProps['candidate'];
}

export const ContactInfo: React.FC<ContactInfoProps> = ({ candidate }) => (
	<>
		<CardHeader title="Contact" />
		<Divider sx={style.divider} />
		<CardContent>
			<Grid container spacing={2}>
				<Grid size={{ xs: 6 }}>
					<Typography variant="subtitle1" gutterBottom>
						Phone
					</Typography>
					<Typography variant="body1" gutterBottom>
						{candidate?.phone}
					</Typography>
				</Grid>
				<Grid size={{ xs: 6 }}>
					<Typography variant="subtitle1" gutterBottom>
						Email
					</Typography>
					<Typography variant="body1" gutterBottom>
						{candidate?.email}
					</Typography>
				</Grid>
			</Grid>
		</CardContent>
	</>
);
